import { render, staticRenderFns } from "./CategorySlide.vue?vue&type=template&id=9c12ab92&"
import script from "./CategorySlide.vue?vue&type=script&lang=js&"
export * from "./CategorySlide.vue?vue&type=script&lang=js&"
import style0 from "./CategorySlide.vue?vue&type=style&index=0&id=9c12ab92&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsCard: require('/var/www/pb-store/components/ProductsCard.vue').default,ModalProducts: require('/var/www/pb-store/components/ModalProducts.vue').default})
